<div
  lass="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex"
>
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  <div
    class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
  >
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6">
      <div class="bg-white shadow-sm-light">
        <app-info-appel
          [base]="'application'"
          [cohorte]="cohorte"
        ></app-info-appel>

        <div class="border-b border-gray-200 dark:border-gray-700">
          <ul
            class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
          >
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/candidatures/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd"
                  />
                </svg>

                Candidatures
              </a>
            </li>
            <!-- <li class="me-2">
              <a [routerLink]="['/dashboard/appels/deliberation/'+cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
                aria-current="page">
                <svg class="w-6 h-6 text-gray-800 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                  height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Zm-1 9a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Zm2-5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm4 4a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z"
                    clip-rule="evenodd" />
                </svg>
                Déliberation
              </a>
            </li> -->
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/admis/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                    clip-rule="evenodd"
                  />
                </svg>

                Admis
              </a>
            </li>
            <!-- <li class="me-2">
              <a [routerLink]="['/dashboard/appels/nonadmis/'+cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group">
                <svg class="w-6 h-6 text-gray-800 dark:text-white mr-2" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd"
                    d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5.757-1a1 1 0 1 0 0 2h8.486a1 1 0 1 0 0-2H7.757Z"
                    clip-rule="evenodd" />
                </svg>
                Non&nbsp;Admis
              </a>
            </li> -->
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/statistiques/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
              >
                <svg
                  class="w-6 h-6 text-blue-600 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v15a1 1 0 0 0 1 1h15M8 16l2.5-5.5 3 3L17.273 7 20 9.667"
                  />
                </svg>
                Statistiques
              </a>
            </li>
            <li class="me-2">
              <a
                [routerLink]="['/dashboard/appels/test/' + cohorte]"
                class="font-semibold inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
              >
                <svg
                  class="w-6 h-6 text-gray-800 dark:text-white mr-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2Zm6 1h-4v2H9a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2h-1V4Zm-6 8a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
                    clip-rule="evenodd"
                  />
                </svg>
                Test&nbsp;d'admission
              </a>
            </li>
            <!-- <li>
            <a
              class="inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500"
              >Disabled</a
            >
          </li> -->
          </ul>
        </div>

        <!-- <div class="tabs-admis px-3">
      <div class="mb-4 border-b border-white dark:border-gray-700">
        <ul
          class="justify-center flex flex-wrap -mb-px text-sm text-gray-700 font-medium text-center"
          id="default-tab"
          data-tabs-toggle="#default-tab-content"
          role="tablist"
        >
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-gray-800 focus:ring-4 focus:ring-gray-300 w-fit text-white mat-mdc-input-element bg-gray-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-red-700 dark:focus:ring-red-900"
              [routerLink]="['/dashboard/appels/candidatures/'+cohorte]"
              type="button"
              role="tab"
              aria-controls="candidatures"
            >
              Candidatures
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 w-fit text-white mat-mdc-input-element bg-blue-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-blue-700 dark:focus:ring-blue-900"
              [routerLink]="['/dashboard/appels/deliberation/'+cohorte]"
              type="button"
              role="tab"
              aria-controls="deliberation"
            >
              Déliberation
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-green-800 bg-green-500 focus:ring-4 focus:ring-green-300 w-fit text-white mat-mdc-input-element inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-green-700 dark:focus:ring-green-900"
              [routerLink]="['/dashboard/appels/admis/'+cohorte]"
              type="button"
              role="tab"
              aria-controls="admis"
            >
              Liste des admis
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-red-800 focus:ring-4 focus:ring-red-300 w-fit text-white mat-mdc-input-element bg-red-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-red-700 dark:focus:ring-red-900"
              [routerLink]="['/dashboard/appels/nonadmis/'+cohorte]"
              type="button"
              role="tab"
              aria-controls="nonadmis"
            >
              Liste non admis
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-red-800 focus:ring-4 focus:ring-red-300 w-fit text-white mat-mdc-input-element bg-red-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-red-700 dark:focus:ring-red-900"
              [routerLink]="['/dashboard/appels/statistiques/'+cohorte]"
              [attr.aria-selected]="true"
              type="button"
              role="tab"
              aria-controls="Statistiques"
            >
              Statistiques
            </button>
          </li>
          <li class="me-2" role="presentation">
            <button
              class="focus:outline-none hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 w-fit text-white mat-mdc-input-element bg-blue-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-blue-700 dark:focus:ring-blue-900"
              [routerLink]="['/dashboard/appels/test/'+cohorte]"
              type="button"
              role="tab"
              aria-controls="deliberation"
            >
              Test
            </button>
          </li>
        </ul>
      </div>
    </div> -->
        <!-- </div>
</div> -->
        <div
          class="w-full p-1 bg-white delib-screen admis flex-col justify-start items-start gap-2.5 inline-flex"
        >
          <div
            class="w-full p-8 bg-white flex-col justify-start items-start gap-2.5 inline-flex"
          >
            <div
              class="self-stretch h-full flex-col justify-start items-start gap-2 flex"
            >
              <div
                class="self-stretch flex-col justify-start items-start gap-6 flex"
              >
                <div
                  class="self-stretch h-[66px] flex-col justify-start items-start gap-1 flex"
                >
                  <div
                    class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex"
                  >
                    <div
                      class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
                    >
                      <div
                        class="self-stretch text-center text-gray-900 text-3xl font-semibold mt-5"
                      >
                        Statistiques
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="self-stretch flex-col justify-start items-center gap-6 flex"
              >
                <div
                  class="w-full p-1 justify-start items-end tarte-tab-ctnr gap-2.5 inline-flex overflow-x-auto"
                >
                  <div class="flex tarte-ctnr">
                    <div class="mt-4">
                      <canvas
                        id="canvasCountAdmisNoAdmis"
                        class="chart-canvas"
                      ></canvas>
                    </div>
                  </div>

                  <div class="flex tab-ctnr">
                    <div class="mt-4">
                      <canvas
                        id="canvasCityAndGender"
                        class="chart-canvas"
                      ></canvas>
                    </div>
                  </div>
                </div>
                <div
                  class="w-full p-1 justify-start items-end tarte-tab-ctnr gap-2.5 inline-flex overflow-x-auto"
                >
                  <div class="flex tarte-ctnr">
                    <div class="mt-4">
                      <canvas id="canvasFamily" class="chart-canvas"></canvas>
                    </div>
                  </div>

                  <div class="flex tab-ctnr">
                    <div class="mt-4">
                      <canvas id="canvasGlobal" class="chart-canvas"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
